import { css } from "../../../../../../styled-system/css";

export const styles = {
  sectionWrapper: () =>
    css({
      flex: 1,
    }),
  childLimiter: () =>
    css({
      display: "flex",
      flexDirection: "column",
      gap: "baseUnit.mobile3",
      marginBottom: "baseUnit.mobile6",
      "& a:nth-of-type(n+4)": {
        display: "none",
      },
      tablet: {
        "& a:nth-of-type(n+3)": {
          display: "none",
        },
      },
      desktop: {
        marginBottom: 0,
      },
    }),
};
